import React from 'react';
import { View, Text, StyleSheet, ScrollView, Dimensions } from 'react-native';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTheme } from '../contexts/ThemeContext';

const { width } = Dimensions.get('window');

const TermsOfServiceScreen = () => {
    const { colors } = useTheme();
    const isMobile = width < 768;

    const styles = StyleSheet.create({
        container: { flex: 1, backgroundColor: colors.background },
        scrollView: { flex: 1 },
        hero: {
            backgroundColor: '#1a1a4e',
            paddingVertical: 60,
            paddingHorizontal: 20,
        },
        heroContent: {
            maxWidth: 800,
            alignSelf: 'center',
            alignItems: 'center',
        },
        heroTitle: {
            fontSize: isMobile ? 28 : 40,
            fontWeight: '800',
            color: '#c9a44e',
            textAlign: 'center',
            marginBottom: 12,
        },
        heroSubtitle: {
            fontSize: 15,
            color: 'rgba(255,255,255,0.7)',
            textAlign: 'center',
        },
        content: {
            paddingVertical: 60,
            paddingHorizontal: 20,
            backgroundColor: '#fff',
        },
        contentContainer: {
            maxWidth: 800,
            alignSelf: 'center',
            width: '100%',
        },
        lastUpdated: {
            fontSize: 14,
            color: '#6b7280',
            marginBottom: 30,
        },
        section: {
            marginBottom: 32,
        },
        sectionTitle: {
            fontSize: 20,
            fontWeight: '700',
            color: '#1a1a4e',
            marginBottom: 12,
        },
        paragraph: {
            fontSize: 15,
            color: '#374151',
            lineHeight: 26,
            marginBottom: 12,
        },
        bulletList: {
            marginLeft: 16,
            marginBottom: 12,
        },
        bulletItem: {
            fontSize: 15,
            color: '#374151',
            lineHeight: 26,
            marginBottom: 6,
        },
    });

    return (
        <View style={styles.container}>
            <Header />
            <ScrollView style={styles.scrollView}>
                <View style={styles.hero}>
                    <View style={styles.heroContent}>
                        <Text style={styles.heroTitle}>Terms of Service</Text>
                        <Text style={styles.heroSubtitle}>Please read these terms carefully before using our services</Text>
                    </View>
                </View>

                <View style={styles.content}>
                    <View style={styles.contentContainer}>
                        <Text style={styles.lastUpdated}>Last Updated: December 2024</Text>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>1. Acceptance of Terms</Text>
                            <Text style={styles.paragraph}>
                                By accessing or using Modern Munshiji's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>2. Description of Services</Text>
                            <Text style={styles.paragraph}>Modern Munshiji provides:</Text>
                            <View style={styles.bulletList}>
                                <Text style={styles.bulletItem}>• GST registration and return filing services</Text>
                                <Text style={styles.bulletItem}>• Income Tax Return (ITR) filing assistance</Text>
                                <Text style={styles.bulletItem}>• Business registration services (Proprietorship, Partnership, LLP, Pvt Ltd)</Text>
                                <Text style={styles.bulletItem}>• RTO documentation and vehicle-related services</Text>
                                <Text style={styles.bulletItem}>• Financial calculators and tools</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>3. User Responsibilities</Text>
                            <Text style={styles.paragraph}>You agree to:</Text>
                            <View style={styles.bulletList}>
                                <Text style={styles.bulletItem}>• Provide accurate and complete information</Text>
                                <Text style={styles.bulletItem}>• Submit authentic documents for processing</Text>
                                <Text style={styles.bulletItem}>• Respond promptly to queries and requests</Text>
                                <Text style={styles.bulletItem}>• Pay fees for services as agreed</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>4. Service Delivery</Text>
                            <Text style={styles.paragraph}>
                                We strive to complete all filings within the stipulated timelines. However, processing times may vary based on government portal availability and document completeness. We are not liable for delays caused by external factors.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>5. Limitation of Liability</Text>
                            <Text style={styles.paragraph}>
                                Modern Munshiji acts as a facilitation service and is not liable for penalties, fines, or consequences arising from incorrect information provided by users, changes in government regulations, or decisions made by tax authorities.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>6. Payment Terms</Text>
                            <Text style={styles.paragraph}>
                                Service fees are communicated upfront. Payment is required before or upon completion of services as agreed. All fees are non-refundable once services have been initiated unless otherwise specified.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>7. Intellectual Property</Text>
                            <Text style={styles.paragraph}>
                                All content, calculators, tools, and materials on this website are the intellectual property of Modern Munshiji and may not be reproduced without permission.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>8. Governing Law</Text>
                            <Text style={styles.paragraph}>
                                These terms are governed by the laws of India. Any disputes shall be resolved in the courts of appropriate jurisdiction.
                            </Text>
                        </View>
                    </View>
                </View>

                <Footer />
            </ScrollView>
        </View>
    );
};

export default TermsOfServiceScreen;
